export const SIZE_GRID = [
    'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL',
    'FREE SIZE', 'ONE SIZE',
    'W25L30', 'W26L30', 'W27L30', 'W28L30', 'W25L32', 'W26L32', 'W27L32', 'W28L32',
    'W29L30', 'W29L32', 'W30L30', 'W30L32', 'W31L30', 'W31L32', 'W32L30', 'W32L32',
    '80', '85'
] as const;
